var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ErrorText, FileInputArea, FileInputWrapper, LabelFileInput, LoadingInput, TextFileInput, } from '../StyledKYCComponents';
import { getUploadedDocumentById, } from '../../../../../Services/methods/verifications';
import { FilePreview } from './FilePreview';
import { DocWithoutPhotoIcon, DocWithPhotoIcon } from '../Icons';
var SUM_SUB_FILE_FORMAT = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'video/mp4',
    'video/webm',
    'video/quicktime',
];
var fileFormatString = SUM_SUB_FILE_FORMAT.join(', ');
var ImageMap = new Map();
var FileInput = function (_a) {
    var _b;
    var name = _a.name, onDelete = _a.onDelete, fileId = _a.fileId, reviewResult = _a.reviewResult, loadDocument = _a.loadDocument;
    var _c = useState(fileId ? (_b = ImageMap.get(fileId)) === null || _b === void 0 ? void 0 : _b.file : undefined), image = _c[0], setImage = _c[1];
    var _d = useState(false), isPdf = _d[0], setIsPdf = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(), error = _f[0], setError = _f[1];
    var label = useMemo(function () {
        if (!name) {
            return 'Upload the document';
        }
        var docSubTypeName = name.split('_').join(' ').toLowerCase();
        return "Upload ".concat(docSubTypeName);
    }, [name]);
    var handleErrorCatch = useCallback(function () {
        setError('Something went wrong. Please, try again');
    }, []);
    var handleDelete = useCallback(function () {
        if (fileId) {
            setLoading(true);
            setError(undefined);
            onDelete(fileId)
                .catch(handleErrorCatch)
                .finally(function () {
                setImage(undefined);
                setLoading(false);
            });
        }
    }, [fileId, handleErrorCatch, onDelete]);
    useEffect(function () {
        if (fileId) {
            var existFile = ImageMap.get(fileId);
            if (existFile) {
                setImage(existFile.file);
                setIsPdf(existFile.isPdf);
            }
            else {
                getUploadedDocumentById(fileId)
                    .then(function (res) {
                    return {
                        file: res.data,
                        fileType: res.headers['file-type'],
                    };
                })
                    .then(readFileAsync)
                    .then(function (_a) {
                    var file = _a.file, isPdf = _a.isPdf;
                    ImageMap.set(fileId, { file: file, isPdf: isPdf });
                    setImage(file);
                    setIsPdf(isPdf);
                });
            }
        }
    }, [fileId]);
    var handleChange = useCallback(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, subType, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError(undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    file = e.target.files ? e.target.files[0] : null;
                    if (!file) {
                        new Error("Can't find file");
                        return [2 /*return*/];
                    }
                    subType = name;
                    return [4 /*yield*/, loadDocument(file, subType)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [loadDocument, name]);
    return (_jsxs(FileInputWrapper, { children: [loading ? (_jsx(LoadingInput, {})) : fileId ? (_jsx(FilePreview, { image: image, isPdf: isPdf, onDelete: handleDelete })) : (_jsx(_Fragment, { children: _jsxs(LabelFileInput, __assign({ htmlFor: name }, { children: [name || name === 'FRONT_SIDE' ? (_jsx(DocWithoutPhotoIcon, {})) : (_jsx(DocWithPhotoIcon, {})), _jsx(TextFileInput, { children: label }), _jsx(FileInputArea, { type: "file", accept: fileFormatString, id: name, required: true, value: undefined, onChange: handleChange, disabled: Boolean(fileId) })] })) })), _jsx(ErrorText, { children: reviewResult || error })] }));
};
export default React.memo(FileInput);
function readFileAsync(_a) {
    var file = _a.file, fileType = _a.fileType;
    var blobURL = URL.createObjectURL(file);
    var isPdf = fileType ? fileType.includes('pdf') : false;
    return new Promise(function (resolve) {
        resolve({ isPdf: isPdf, file: blobURL });
    });
}
